export const ROUTES = {
	contacts: {
		cs: "kontakty",
		sk: "kontakty",
		en: "contacts",
	},
	wedding: {
		cs: "svatebni-saty",
		sk: "svadobne-saty",
		en: "wedding-dress",
	},
	schoolWedding: {
		cs: "poloneza",
		sk: "poloneza",
		en: "polonaise",
	},
	action: {
		cs: "akce",
		sk: "akcie",
		en: "actions",
	},
	formal: {
		cs: "spolecenske-saty",
		sk: "spolocenske-saty",
		en: "formal-dress",
	},
	ourCommodity: {
		cs: "nase-nabidka",
		sk: "nasa-ponuka",
		en: "our-commodity",
	},
	galeries: {
		cs: "galerie",
		sk: "galerie",
		en: "galleries",
	},
	galleryWedding: {
		cs: "galerie-svatba",
		sk: "galerie-svadba",
		en: "gallery-wedding",
	},
	gallerySchoolWedding: {
		cs: "galerie-poloneza",
		sk: "galerie-poloneza",
		en: "gallery-polonaise",
	},
	galleryAction: {
		cs: "galerie-akce",
		sk: "galerie-akcie",
		en: "gallery-actions",
	},
	galleryAddons: {
		cs: "galerie-doplnky",
		sk: "galerie-doplnky",
		en: "gallery-addons",
	},
	galleryFormal: {
		cs: "galerie-spolecenske-saty",
		sk: "galerie-spolocenske-saty",
		en: "gallery-formal-dress",
	},
	galleryShop: {
		cs: "galerie-prodejna",
		sk: "galerie-predajna",
		en: "gallery-shop",
	},
	home: {
		cs: "uvod",
		sk: "uvod",
		en: "home",
	},
	gdpr: {
		cs: "gdpr",
		sk: "gdpr",
		en: "gdpr",
	},
	upload: {
		cs: "nahravani",
		sk: "nahravanie",
		en: "upload",
	},
	page404: {
		cs: "404",
		sk: "404",
		en: "404",
	},
	edit: {
		cs: "upravy",
		sk: "upravy",
		en: "edit",
	},
};
export const PAGGING_MAX_PAGES = 5;
export const FIRST_PAGE = 1;
export const IMAGE_REPLACE = "#s";
export const SMALL_IMAGE = "s";
export const LARGE_IMAGE = "l";
export const COOKIE_NAME = "cookieAllowIvana";
export const GALLERY_PREVIEW_SMALL_COUNT = 2;
export const GALLERY_PREVIEW_LARGE_COUNT = 3;
export const GALLERY_WEDDING_SMALL_COUNT = 6;
export const KEYS = {
	ESC: "Escape",
	LEFT: "ArrowLeft",
	RIGHT: "ArrowRight",
	UP: "ArrowUp",
	DOWN: "ArrowDown",
	ENTER: "Enter",
};
export const SHOW_CHRISTMAS = false;
export const ALL_LANGS = ["cs", "sk", "en"];
export const SMALL_DEVICE_QUERY = "(max-width: 930px)";
